/**
 * Named rate-card API client + Rate Card group rows.
 */

import api from "@/shared/api";

export async function fetchRateCardGroups() {
  const response = await api.get("/pricing/ops/groups");
  return response.data?.data ?? response.data;
}

export async function fetchGroupRows(groupId, { cardId } = {}) {
  const response = await api.get(
    `/pricing/ops/groups/${encodeURIComponent(groupId)}/rows`,
    cardId ? { params: { cardId } } : undefined
  );
  return response.data?.data ?? response.data;
}

/** @deprecated Prefer fetchGroupRows('shared_load') */
export async function fetchSharedLoadRows() {
  return fetchGroupRows("shared_load");
}

export async function saveGroupRows(groupId, { rows, params, cardId } = {}) {
  const response = await api.put(
    `/pricing/ops/groups/${encodeURIComponent(groupId)}/rows`,
    { rows, params, cardId }
  );
  return response.data?.data ?? response.data;
}

/** @deprecated Prefer saveGroupRows('shared_load', { rows }) */
export async function saveSharedLoadRows(rows) {
  return saveGroupRows("shared_load", { rows });
}

export async function fetchNamedRateCards() {
  const response = await api.get("/pricing/ops/cards");
  return response.data?.data ?? response.data;
}

export async function setEditingRateCard(cardId) {
  const response = await api.post("/pricing/ops/cards/set-editing", { cardId });
  return response.data?.data ?? response.data;
}

export async function setLiveRateCard(cardId) {
  const response = await api.post("/pricing/ops/cards/set-live", { cardId });
  return response.data?.data ?? response.data;
}

export async function duplicateRateCard({ sourceId, newId, version } = {}) {
  const response = await api.post("/pricing/ops/cards/duplicate", {
    sourceId,
    newId,
    version,
  });
  return response.data?.data ?? response.data;
}

export async function setProviderMethodologyEnabled(enabled) {
  const response = await api.put("/pricing/ops/cards/methodology", { enabled });
  return response.data?.data ?? response.data;
}

export async function testSuggestedPrice(payload) {
  const response = await api.post("/pricing/ops/test-suggested-price", payload);
  return response.data?.data ?? response.data;
}

export async function resolvePricingSeason(payload = {}) {
  const response = await api.post("/pricing/ops/season/resolve", payload);
  return response.data?.data ?? response.data;
}

/** Current + upcoming season for ops / marketing prep. */
export async function fetchSeasonBriefing(params = {}) {
  const response = await api.get("/pricing/ops/season/briefing", { params });
  return response.data?.data ?? response.data;
}
